import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { AbstractMedia } from 'types/AbstractMedia';

import CachedMedia, { CachedMediaType } from 'utils/CachedMedia';

import { getKioskName } from 'modules/dealers/selectors';

import { Spinner, Button } from 'components/ui';
import { ButtonType } from 'components/ui/Button';
import { DEFAULT_MEDIA_COMPONENTS } from 'components/ui/File';

const MEDIA_PROPS = {
  muted: true,
  autoplay: false,
  disableAutoPause: true,
  controls: false,
  hideFilename: true,
  className: 'absolute w-full h-full object-cover',
};

type StyleProperties = React.CSSProperties & {
  [key: `--${string}`]: string | number;
};

const Slide: React.FC<{ media: AbstractMedia, onClose?: () => void, className?: string, style?: StyleProperties }> = ({ media, onClose, className, style }) => {
  const [file, setFile] = React.useState<AbstractMedia>(null);

  const kioskName = useSelector(getKioskName);

  const cachedMedia = React.useMemo(() => new CachedMedia(media as CachedMediaType), [media]);

  React.useEffect(() => {
    cachedMedia.getAsAbstractMedia()
      .then(setFile)
      .catch(() => setFile(media));
  }, [cachedMedia, media]);

  return (
    <div className={className} style={style} data-slide-id={media.id}>
      {!file && <Spinner />}
      {file && (
        <div className="homePage">
          <div className="absolute top-20 z-10 w-screen px-4xl flex justify-center text-center text-white text-5xl capitalize !text-shadow-lg" >
            {kioskName}
          </div>
          {DEFAULT_MEDIA_COMPONENTS[file.type]?.(file, MEDIA_PROPS)}
          <div className="absolute w-screen bottom-0 z-10">
            <div className="flex flex-col w-full m-auto max-w-4xl kiosk:w-full px-7 kiosk:px-12">
              <Button
                type={ButtonType.PRIMARY}
                className="flex items-center justify-center !drop-shadow-md btn-home-primary mb-20"
                onClick={onClose}
                testId={`close-screensaver-${media.id}`}
              >
                <FormattedMessage id="home.startSelfService" defaultMessage="Start self-service here" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Slide;
